
export const findUrgencyCodeDescriptionId = (inputCode) => {
  let idCodes = [
    'monitoraggioPazientePage.codiceUrgenzaRosso',
    'monitoraggioPazientePage.codiceUrgenzaArancione',
    'monitoraggioPazientePage.codiceUrgenzaBlu',
    'monitoraggioPazientePage.codiceUrgenzaVerde',
    'monitoraggioPazientePage.codiceUrgenzaBianco'
  ];

  const parsedInputCode = parseInt(inputCode, 10);
  const codeTranslationLabel = idCodes[parsedInputCode - 1];

  return codeTranslationLabel || 'monitoraggioPazientePage.codiceUrgenzaSconosciuto';
}